var exports = {
  "Sl": "xaf9ae18d--055df9--image",
  "VN": "xaf9ae18d--055df9--close",
  "Qs": "xaf9ae18d--055df9--content",
  "pq": "xaf9ae18d--055df9--info",
  "wm": "xaf9ae18d--055df9--logo",
  "Cv": "xaf9ae18d--055df9--copyright",
  "mm": "xaf9ae18d--055df9--mobile-banner",
};

module.exports = exports;
